import { useMemo } from 'react'
import {
  type GanttCard,
  type GanttCategory,
  getCardLayoutMap
} from '../Gantt.utils'

type UseGanttCardLayoutArgs = {
  cards: GanttCard[]
  categories: GanttCategory[]
  year: number
  timelineWidth: number
}

const useGanttCardLayout = ({
  cards,
  categories,
  year,
  timelineWidth
}: UseGanttCardLayoutArgs) => {
  const { cardLayoutMap, rowList, totalBodyHeight } = useMemo(
    () =>
      getCardLayoutMap({
        cards,
        categories,
        year,
        timelineWidth
      }),
    [cards, categories, year, timelineWidth]
  )

  const cardOrderMap = useMemo(
    () =>
      cards.reduce<Record<string, number>>((accumulator, card, index) => {
        accumulator[card.id] = index
        return accumulator
      }, {}),
    [cards]
  )

  return { cardLayoutMap, rowList, totalBodyHeight, cardOrderMap }
}

export default useGanttCardLayout
